import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertPopupComponent } from './../../../../shared/components/alert-popup/alert-popup.component';
import { ValidationMessage } from './../../../../shared/constants/constant';

@Injectable()
export class ErrorDialogService {
    public isDialogOpen: Boolean = false;
    constructor(public dialog: MatDialog) { }
    openDialog(errorMessage): any {
        if (this.isDialogOpen) {
            return false;
        }
        this.isDialogOpen = true;
        const dialogRef = this.dialog.open(AlertPopupComponent, {
            width: '600px',
            data: {
                title: 'Error',
                Message: errorMessage,
                showCancelButton: true,
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
            this.isDialogOpen = false;
        });
    }
}